import Vue from 'vue';

window.axios = require('axios');

window.eventHttpClient = axios.create()
window.eventHttpClient.defaults.baseURL = LaraVue.events.apiUrl;
window.eventHttpClient.defaults.timeout = 10000;

window.coreApiClient = axios.create()
window.coreApiClient.defaults.baseURL = LaraVue.core.url;
window.coreApiClient.defaults.timeout = 10000;
window.coreApiClient.interceptors.request.use(config => {
    config.headers['X-CSRF-TOKEN'] = window.LaraVue.csrfToken;
    config.headers['X-Requested-With'] = 'XMLHttpRequest';

    const token = localStorage.getItem('jwtToken')

    if (token) config.headers['Authorization'] = 'Bearer ' + token;

    return config;
}, error => {
    return Promise.reject(error);
});

import SocialSharing from 'vue-social-sharing';
Vue.use(SocialSharing);

import locale from 'element-ui/lib/locale/lang/en';
import ElementUI from 'element-ui';
Vue.use(ElementUI, { locale });

window._ = require('lodash');
window.Numeral = require('numeral');
window.ScrollMagic = require('scrollmagic');
window.dateFns = require('date-fns');

require('promise/polyfill-done');
